import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { fade } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles(({ palette, spacing }) => ({
  cell: {
    minWidth: "200px",
    maxWidth: "270px",
    width: "100%",
    minHeight: "48px",
    height: "auto",
    overflow: "hidden",
    padding: spacing(0, 1.5),
    borderRight: `1px solid ${palette.separator.main}`,
    borderBottom: `1px solid ${palette.separator.main}`,
    color: palette.contrastText.main,
    background: palette.attachmentsBackground.main,
  },
  fileViewContainer: {
    background: palette.attachmentsBackground.main,
    width: "100%",
  },
  selectMenu: {
    backgroundColor: palette.otherElementsBackground.main,
  },
  menuItem: {
    color: palette.contrastText.main,
  },
  cellInput: {
    border: `1px solid ${palette.separator.main}`,
    background: palette.otherElementsBackground.main,
    color: palette.contrastText.main,
    borderRadius: "2px",
    height: "24px",
    width: "100%",
    padding: spacing(0, 0.5),
  },
  textResponseInput: {
    fontSize: "12px",
    padding: "2px 20px 2px 4px",
    width: "100%",
    color: palette.contrastText.main,
    background: "transparent",
    resize: "none",
    boxSizing: "border-box",
    "&:disabled": {
      background: palette.otherElementsBackground.main,
    },
    "&:hover": {
      borderColor: palette.primary.main,
    },
    "&:focus": {
      borderColor: palette.primary.main,
      color: palette.contrastText.main,
      background: fade(palette.contrastText.main, 0.1),
      outline: "none",
    },
  },
  optionsResponseInput: {
    fontSize: "12px",
    padding: "3px 0",
    whiteSpace: "normal",
    "& svg": {
      fill: palette.contrastIcon.main,
    },
    "& > div": {
      color: palette.contrastText.main,
    },
    "& input": {
      color: palette.contrastText.main,
    },
    "& fieldset": {
      borderColor: palette.secondaryContrast.main,
    },
    "& label": {
      color: palette.contrastText.main,
    },
    "&.Mui-error fieldset": {
      borderColor: `${palette.error.main} !important`,
    },
    "&:hover fieldset": {
      borderColor: `${palette.primary.main} !important`,
    },
    "&.Mui-focused fieldset": {
      borderColor: `${palette.primary.main} !important`,
    },
  },
  optionViewValue: {
    fontSize: "12px",
    color: palette.contrastText.main,
    whiteSpace: "normal",
    wordBreak: "break-word",
    width: "100%",
    padding: spacing(0.5, 0.5),
  },
  cellInputText: {
    fontSize: "12px",
    lineHeight: "120%",
    color: palette.contrastText.main,
    background: "transparent",
    whiteSpace: "nowrap",
  },
  cellButton: {
    padding: 0,
  },
  cellResponse: {
    padding: spacing(1.5),
  },
  subjectButton: {
    width: "16px",
    height: "16px",
  },
  subjectIcon: {
    width: "16px",
    height: "16px",
    color: grey[500],
  },
  makeColumnMandatoryButton: {
    position: "absolute",
    padding: "4px",
    minWidth: "16px",
    right: 0,
    "& *": {
      visibility: "visible",
    },
    "& .MuiButton-label": {
      width: "16px",
    },
  },
  selectPlaceholder: {
    top: "-14px",
    left: "-7px",
    fontSize: "12px",
    color: palette.secondaryContrast.main,
  },
  selectPlaceholderShrink: {
    transform: "translate(12px, 3px) scale(0.85) !important",
  },
  errorField: {
    border: `1px solid ${palette.error.main}`,
    borderRadius: "2px",
    "& fieldset": {
      border: `1px solid ${palette.error.main}`,
    },
  },
}));

export default useStyles;
